module.exports = __webpack_public_path__ + "static/menu-illupino-min3-978c569f94728220647eac1fd3d1bb3f.jpg";